import reducer from './reducers';

export { default as configOperations } from './operations';
export { default as configTypes } from './types';

export default reducer;
